import { useEffect, useState } from 'react';
import CreateFormSection from 'components/UI/atoms/CreateFormSection';
import SchemaUIExtractor from 'components/UI/organisms/SchemaUIExtractor';
import ChallengesTaskAndQuestionsListing from './ChallengesTaskAndQuestionsListing';
import { Radio } from '@mui/material';
import { stepSchema } from '../data';

const EVALUATION_TYPES = [
  {
    title: 'Any Template',
    description: 'Allow participants to choose any template from template library in projects',
    templateValue: {
      value: 'Any Template',
      key: 'any',
    },
  },
  {
    title: 'Create New',
    description: 'Create a new template with custom Challenge tasks and questions',
    templateValue: {
      value: 'Custom Tasks and Questions',
      key: 'custom',
    },
  },
  {
    title: 'Pick From Template Library',
    description: 'Choose a particular template for participants to use in projects',
    templateValue: null,
  },
];

const TaskAndChallenge = ({
  t = (d) => d,
  data,
  errors,
  onChange,
  step,
  taskValues,
  setTaskValues,
  questionsValues,
  setQuestionsValues,
  taskAndQuestionError,
  setTaskAndQuestionError,
  isProjectAlreadyPublished,
}) => {
  const [option, setOption] = useState(0);

  const updatedSchema = stepSchema(step)
    .slice(0, 1)
    .map((schema) => ({
      ...schema,
      disabled: isProjectAlreadyPublished,
    }));

  const handleOptionChange = (index) => {
    setOption(index);
    onChange({
      target: {
        name: 'template_id',
        value: EVALUATION_TYPES[index].templateValue,
      },
    });
  };

  const selectedTemplateKey = data?.template_id?.key;

  const isUsingLibraryTemplate = selectedTemplateKey !== 'any' && selectedTemplateKey !== 'custom' && option;

  useEffect(() => {
    const key = data.template_id?.key;
    setOption(key === 'custom' ? 1 : key === 'any' || key === 0 ? 0 : 2);
  }, []);


  return (
    <CreateFormSection
      title={t("Challenge Tasks and Questions")}
      classes={`w-full my-2 ${isProjectAlreadyPublished ? "opacity-50" : ""}`}
    >
      <p className="fs-15 opacity-60">
        {t('Set the Challenge template for Project submissions.')}
      </p>
    <h4 className='py-2'>{t("Template")} <span className='fs-14 text-danger'>*</span></h4>
    <div className=' pb-4'>
      {EVALUATION_TYPES.map(({ title, description }, i) => (
        <div key={title} className="flex items-center fs-14 flex-wrap">
          <Radio
            checked={option === i }
            onClick={() => handleOptionChange(i)}
            disabled={isProjectAlreadyPublished}
          />
          <p className="mr-2">{t(title)}</p>
          <p className="opacity-60">{t(description)}</p>
        </div>
      ))}
    </div>

      {!!isUsingLibraryTemplate  && (
        <SchemaUIExtractor
          schema={updatedSchema}
          data={data}
          errors={errors}
          onChange={onChange}
          template="task"
        />
      )}
      
      {data?.template_id && (selectedTemplateKey !== 'any' && selectedTemplateKey !== 0 ) && (
        <ChallengesTaskAndQuestionsListing
          templateId={selectedTemplateKey}
          taskValues={taskValues}
          setTaskValues={setTaskValues}
          questionsValues={questionsValues}
          setQuestionsValues={setQuestionsValues}
          taskAndQuestionError={taskAndQuestionError}
          setTaskAndQuestionError={setTaskAndQuestionError}
          isProjectAlreadyPublished={isProjectAlreadyPublished}
          t={t}
        />
      )}
    </CreateFormSection>
  );
};

export default TaskAndChallenge;
